<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="titlepage">
<a id="page06">
</a><a id="page07">
<h2 class="titlePageTitle">Everything Here Is the Best Thing Ever</h2>
<p class="titlePageSubtitle">Stories</p>
<h2 class="titlePageAuthor">Justin Taylor</h2>
<p class="paraCenter"><img alt="image" src="Images/logo.jpg"/></p>
</a></div>
<a id="page07">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?52747ebb